import { stylesheet } from 'astroturf';
import Svg from 'src/components/Svg';
import styled from 'astroturf/react';

const Cell = styled('div')`
  flex: 1;

  &:nth-child(2) {
    flex: 0 0 36%;
    word-break: break-all;
  }

  &:nth-child(3) {
    flex: 0 0 18%;
  }

  &:only-child {
    flex: 1;
  }

  &.label {
    color: var(--ph-gray-500);
  }
`;
  
const Classes = stylesheet`
  .icon {
    line-height: 17px; 
  }
  .ml-auto {
    margin-left: 70%;
  }
  .mt-40 {
    margin-top: 27px;
  }
`;

const Container = styled('div')`
  background: white;
  color: var(--ph-gray-900);
  margin-bottom: 40px;
`;

const Content = styled('div')`
  border-bottom: 2px solid var(--ph-gray-25);
  font-weight: bold;
`;

const ContentDiv = styled('div')`
  text-align: center;
`;

const ContentWrapper = styled('div')`
  margin-bottom: 80px;
  display: grid;
  grid-gap: 6rem;
  grid-template-columns: repeat(6, 1fr);

  @media(max-width: 991px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media(max-width: 450px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const Label = styled('div')`
  font-size: 11px;
  color: var(--ph-gray-900);
`;

const JobNumberLabel = styled('label')`
  font-size: 24px;
  color: var(--ph-light-blue-600);
`;

const QuestionText = styled('div')`
  margin: 40px 0px;
  font-size: 18px;
  position: relative;

  &::before {
    content: "";
    display: block;
    position: absolute;
    left: -13px;
    top: 2px;
    width: 5px;
    height: 100%;
    background: var(--ph-light-blue-600);
  }

  &.grey-text {
    color: var(--ph-gray-900);
  }

  &.space-around-none {
    margin: 0px;
    display: flex;
    align-items: center;
  }
`;

const Row = styled('div')`
  display: flex;
  flex-direction: row;
  page-break-inside: avoid;
  break-inside: avoid;
  justify-content: space-between;
  margin-bottom: 30px;
`;

const Right = styled('div')`
  display: flex;
  justify-content: flex-end;

  &.col-gap {
    width: 30%;
    max-width: 30%;
    column-gap: 8px;

    @media(max-width: 1200px) {
      width: 80%;
      max-width: 100%;
    }
  }
`;

const ResetButtonWrapper = styled('div')`
  display: flex;
  align-items: flex-end;
  margin-bottom: 25px;
`;

const ShareIcon = styled(Svg)`
  width: 22px;
  top: 2px;
  margin-left: 20px;
  cursor: pointer;
  vertical-align: middle;
`;

const SurveyDropdown = styled('div')`
  width: 100%;
`;

const Left = styled('div')`
  display: flex;
  flex: 0 0 35%;
  align-items: center;
`;

const SurveyLabel = styled('label')`
  width: 50%;
  margin-top: 3px;
`;

const StarIcon = styled(Svg)`
  width: 16px;
  margin-right: 4px;
  vertical-align: middle;

  svg path {
    fill: #ffc933;
  }
`;

const SmileyIcon = styled(Svg)`
  width: 20px;
  margin-right: 5px;
  vertical-align: middle;
`;

const SurveySummaryWrapper = styled('div')`
  padding: 20px 20px 20px 40px;
  background-color: var(--white);
  height: 100%;

  &.isPublic {
    height: auto
  }
`;

const TotalResponseIconStyle = stylesheet`
  .svg {
    width: 10px;
    margin-right: 3px;
  }
`;

const Table = styled('table')`
  border-radius: var(--ph-border-radius-sm);
  font-size: 11px;
  width: 100%;
  border-collapse: collapse;

  thead {
    letter-spacing: normal;
    padding: 0 10px;

    tr {
      background-color: var(--grey-bg);
      border-bottom: 1px solid var(--ph-gray-25);
      border-top: 1px solid var(--ph-gray-25);

      &:last-child {
        padding-right: 0px !important;
      }

      td {
        padding: 6px 18px;
      }

      th {
        padding: 0px 6px;

        &:first-child {
          width: 250px;
          max-width: 250px;
          text-align: left;
          padding: 6px 18px;
        }
      }

      table {
        width:100%;

        thead {
          tr:last-child {
            padding-right : 0px;
          }

          td {
            padding: 12px 4px;
            width: 20%;
          }
        }
      }
    }
  }

  tbody {
    tr {
      &:nth-child(even) {
        background-color: var(--grey-bg);
        border-bottom: 1px solid var(--ph-gray-25);
        border-top: 1px solid var(--ph-gray-25);
      }

      td {
        padding: 0px 6px;

        &:first-child {
          text-align: left;
          padding: 6px 18px;

          p {
            margin: 0px;
          }
        }

        table {
          width: 100%;

          tbody {
            td {
              padding: 0px 0px 0px 3px !important;
              min-width: auto;
              height: 14px;
            }
          }
        }
      }
    }
  }

  td, th {
    text-align: right;
  }

  tfoot {
    td {
      font-weight: bold;

      &:first-child {
        text-align: left;
        padding: 6px 18px;
      }

      &:not(first-child) {
        padding: 0 4px;
      }
    }
  }
`;

const TableWrapper = styled('div')`
  margin: 10px 0px;
  width: 100%;
  min-height: .01%;
  overflow-x: auto;
  position: relative;
  margin-top: 10px;
`;

export default {
  Cell,
  Classes,
  Container,
  Content,
  ContentDiv,
  ContentWrapper,
  Label,
  Left,
  QuestionText,
  ResetButtonWrapper,
  Right,
  Row,
  ShareIcon,
  SurveyDropdown,
  SurveyLabel,
  StarIcon,
  SmileyIcon,
  SurveySummaryWrapper,
  Table,
  TableWrapper,
  TotalResponseIconStyle,
  JobNumberLabel,
};
